export const calculateSingleCoverageData = (coverageId, amounts, paymentFrequency) => amounts
        && amounts.reduce(
          (acc, el) => acc + el[paymentFrequency.value][coverageId], 0,
        );

export const calculateSingleCoveragePrice = (
  coverageId,
  prices,
  selectedPaymentFrequency,
) => prices && prices.reduce((acc, el) => {
  if (Object.keys(el[selectedPaymentFrequency.value]).length) {
    return acc + el[selectedPaymentFrequency.value].coverages[coverageId];
  }
  return acc;
}, 0);

export const getPaymentFrequenciesPriceLengths = (
  paymentFrequencies,
) => Object.keys(paymentFrequencies).reduce(
  (acc, item) => ({
    ...acc,
    [item]: Object.values(paymentFrequencies[item]).length,
  }), {},
);

// This function is responsible to map through data.
// In calculator pages, so we are getting data, name is` {no_passport}.
// But in contract steps, in calculator page,
// we are getting data from {passport_id}
export const getCalculatorDiscountedPrice = (prices) => {
  if (Object.keys(prices)) {
    return Object.values(prices).reduce((acc, item) => acc + item.price, 0);
  }
  return 0;
};

export const getActiveCoveragesFromPlan = (plan) => Object.keys(plan).reduce((acc, key) => {
  const { coverages } = plan[key];
  Object.keys(coverages).forEach((coverageKey) => {
    if (coverages[coverageKey] > 0) {
      acc[coverageKey] = (acc[coverageKey] || 0) + coverages[coverageKey];
    }
  });
  return acc;
}, {});

export const getSummaryPricesByKeyFromPlan = (plan, selectedKey) => Object.keys(plan).reduce(
  (acc, item) => {
    Object.keys(plan[item]).forEach((key) => {
      acc[key] = (acc[key] || 0) + plan[item][key];
    });
    return {
      [selectedKey]: acc[selectedKey],
    };
  }, {},
);

export const getDiscountPrice = (policyPrices, selectedPlan) => {
  if (policyPrices[selectedPlan]) {
    const { discountedPrices } = policyPrices[selectedPlan];
    if (discountedPrices) {
      return Object.keys(discountedPrices).reduce(
        (acc, item) => acc + discountedPrices[item].totalSaving, 0,
      );
    }
  }

  return 0;
};
